import React, { useState, useEffect } from 'react'
import {
  Panel,
  Modal,
  Row,
  Col,
  Uploader,
  Icon,
  Table,
  ButtonGroup,
  IconButton,
  Input,
  Button,
  Message,
} from 'rsuite'
import { isImageOrPdf, isValidators, isImageOrPdfOrMsFile } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'

export default function AttachFilesFormProjectEvaluation({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  onSubmit,
  onUpdate,
  onCancel,
  onDelete,
  onPreview,
  onDownload,
  isChangSeqNo = true,
  onChangSeqNo,
  ...props
}) {
  const {
    isEditErr,
    isUploadErr,
    isDeleteError,
    setIsProgress,
    loading,
    disabledUpload,
    disabledEdit,
  } = props
  const { Column, HeaderCell, Cell } = Table
  const [fileList, setFileList] = useState([])
  const [attachFiles, setAttachFiles] = useState([])
  const [selectEditeIndex, setSelectEditeIndex] = useState(-1)
  const [editName, setEditName] = useState()
  const [deleteIndex, setDeleteIndex] = useState()
  const [isAdd, setIsAdd] = useState(false)
  const [isDeleteFail, setIsDeleteFail] = useState(false)
  const [isUploadError, setIsUploadError] = useState(false)
  const [isEditError, setIsEditError] = useState(false)
  const [isdelete, setIsdelete] = useState(false)
  const [disableUpload, setDisableUpload] = useState(false)
  const [listType, setListType] = useState('text')
  const [fileTypeError, setFileTypeError] = useState(false)

  useEffect(() => {
    setIsDeleteFail(isDeleteError)
  }, [isDeleteError])
  useEffect(() => {
    if (!isEditErr) {
      console.log('isEditErr', isEditErr)
    }
    setIsEditError(isEditErr)
  }, [isEditErr])
  useEffect(() => {
    setIsUploadError(isUploadErr)
    setIsAdd(isUploadErr)
  }, [isUploadErr])

  const onAdd = () => {
    setIsAdd(true)
    setFileTypeError(false)
    setFileList([])
  }

  const onAddFile = (file) => {
    setDisableUpload(true)
    setFileList(file)
    setValue(schema.name, file)
    schema.name === 'projectProgressReport' ? setIsProgress(true) : setIsProgress(false)
  }

  const handleDeleteFile = (index) => {
    setDeleteIndex(index)
    setIsdelete(true)
  }

  const handleEditFile = (rowData, index) => {
    setEditName(rowData.label)
    setSelectEditeIndex(index)
  }

  console.log(schema.name)
  console.log(schema.value)

  return (
    <>
      <Row style={{ marginTop: 10 }}>
        <ErrorMessage error={errors[schema.name]} />
      </Row>
      <Controller
        key={schema.name}
        name={schema.name}
        control={control}
        rules={isValidators(schema.validators)}
        defaultValue={fileList}
      />
      <Row style={{ marginTop: 10 }}>
        {fileTypeError && (
          <Message
            style={{ marginTop: 10, marginBottom: 10 }}
            closable
            onClose={() => {
              setFileTypeError(false)
            }}
            showIcon
            type="error"
            description="อัพโหลดชนิดไฟล์ไม่ถูกต้อง *** ชนิดที่รองรับ png , jpeg , jpg , pdf .doc .docx ***"
          />
        )}
        <Uploader
          accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .xlsx"
          autoUpload={false}
          fileList={props.value}
          listType={listType}
          onChange={(files) => {
            let file = files[files.length - 1]
            if (file && isImageOrPdfOrMsFile(file.blobFile.type)) {
              if (files.length > 1) {
                files.splice(0, 1)
              }
              if (file && isImageOrPdf(file.blobFile.type)) {
                setListType('picture-text')
              } else {
                setListType('text')
              }
              onAddFile(files)
              setFileTypeError(false)
            } else {
              files.splice(files.length - 1, 1)
              onAddFile(fileList)
              setFileTypeError(true)
            }
          }}
          draggable
        >
          <div style={{ lineHeight: '100px' }}>
            <Icon size="4x" icon="upload2" />
            <small
              style={{
                marginTop: '-70px',
                display: 'block',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              }}
            >
              คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
            </small>
          </div>
        </Uploader>
      </Row>
      {schema.value && (
        <div
          style={{
            marginTop: '10px',
            marginBottom: '20px',
            padding: '10px',
            borderRadius: '5px',
            backgroundColor: '#F9F9F9',
            boxShadow: '0 4px 10px 0 #DADADA, 0 6px 20px 0 #F8FFF6',
          }}
        >
          <p style={{ fontSize: '12px', fontWeight: 'bold', color: 'black' }}>ไฟล์ที่อัพโหลดแล้ว</p>
          <p style={{ margin: '0px' }}>{schema.value.name}</p>
        </div>
      )}
      {isUploadError && (
        <Row style={{ marginTop: 10 }}>
          <Message
            showIcon
            type="error"
            description={`อัพโหลด${schema.buttonText ? schema.buttonText : ''}ไม่สำเร็จ`}
          />
        </Row>
      )}
      <Row style={{ marginTop: 10 }}>
        <IconButton
          appearance="ghost"
          icon={<Icon appearance="ghost" icon="upload2" className="bt-gost-icon-radius" />}
          onClick={(e) => onSubmit()}
          style={{ marginRight: 5 }}
          disabled={loading || fileList?.length < 1}
        >
          {`อัพโหลด${schema.buttonText ? schema.buttonText : ''}`}
        </IconButton>
        {fileList?.length > 0 && (
          <IconButton
            appearance="ghost"
            className="rs-btn-ghost-cancel"
            icon={<Icon appearance="ghost" icon={'close'} className="bt-gost-icon-radius-cancel" />}
            onClick={(e) => {
              onCancel()
            }}
            style={{ marginRight: 5 }}
            disabled={loading}
          >
            {`ยกเลิก${schema.buttonText ? schema.buttonText : ''}`}
          </IconButton>
        )}

        {schema.value && (
          <>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon={'eye'} className="bt-gost-icon-radius" />}
              onClick={(e) => {
                onPreview(schema.value)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`แสดง${schema.buttonText ? schema.buttonText : ''}`}
            </IconButton>
            <IconButton
              appearance="ghost"
              icon={<Icon appearance="ghost" icon={'download'} className="bt-gost-icon-radius" />}
              onClick={(e) => {
                onDownload(schema.value)
              }}
              style={{ marginRight: 5 }}
              disabled={loading}
            >
              {`ดาวน์โหลด${schema.buttonText ? schema.buttonText : ''}`}
            </IconButton>
          </>
        )}
      </Row>
      <Modal
        show={isdelete}
        onHide={(e) => {
          setIsdelete(false)
        }}
      >
        <Modal.Header>
          <Modal.Title>ยืนยันการลบ</Modal.Title>
        </Modal.Header>
        <Modal.Body>{'ยืนยันการลบไฟล์'}</Modal.Body>
        <Modal.Footer>
          <Button
            onClick={(e) => {
              onDelete(deleteIndex)
              setIsdelete(false)
            }}
            appearance="primary"
          >
            ลบ
          </Button>
          <Button
            onClick={(e) => {
              setIsdelete(false)
              setDeleteIndex('')
            }}
            appearance="subtle"
          >
            ยกเลิก
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}
